import { render, staticRenderFns } from "./Y67TSecondaryEoiList.vue?vue&type=template&id=2290d663&scoped=true&"
import script from "./Y67TSecondaryEoiList.vue?vue&type=script&lang=js&"
export * from "./Y67TSecondaryEoiList.vue?vue&type=script&lang=js&"
import style0 from "./Y67TSecondaryEoiList.vue?vue&type=style&index=0&id=2290d663&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2290d663",
  null
  
)

export default component.exports